module.exports = __webpack_public_path__ + "static/media/home_avatar2.25365f2e.png";